import { render, staticRenderFns } from "./LamboHeaderItem.vue?vue&type=template&id=130f4576&scoped=true&"
import script from "./LamboHeaderItem.vue?vue&type=script&lang=js&"
export * from "./LamboHeaderItem.vue?vue&type=script&lang=js&"
import style0 from "./LamboHeaderItem.vue?vue&type=style&index=0&id=130f4576&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130f4576",
  null
  
)

export default component.exports